import apiClient from '../client';

// ─── Products ─────────────────────────────────────────────────────────────────

export const getProducts = async ({ page = 0, size = 20, sort, search, collection, marketCode } = {}) => {
  const params = { page, size };
  if (sort) params.sort = sort;
  if (search) params.search = search;
  if (collection) params.collection = collection;
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/products', { params });
  return data?.content ?? data ?? [];
};

// Same as getProducts but keeps the page metadata (totalPages) so callers can fetch the rest.
export const getProductsPage = async ({ page = 0, size = 20, sort, marketCode } = {}) => {
  const params = { page, size };
  if (sort) params.sort = sort;
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/products', { params });
  return { items: data?.content ?? data ?? [], totalPages: data?.totalPages ?? 1 };
};

export const getProductByHandle = async (handle, marketCode) => {
  const params = {};
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get(`/products/${handle}`, { params });
  return data;
};

export const searchProducts = async (query, marketCode) => {
  const params = { q: query };
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/search', { params });
  return data?.content ?? data ?? [];
};

export const getBestsellers = async (size = 8, marketCode) => {
  const params = { sort: 'bestseller', size };
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/products', { params });
  return data?.content ?? data ?? [];
};

export const getNewArrivals = async (size = 8, marketCode) => {
  const params = { sort: 'newest', size };
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/products', { params });
  return data?.content ?? data ?? [];
};

export const getProductsByType = async (type, size = 20, marketCode) => {
  const params = { type, size };
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get('/products', { params });
  return data?.content ?? data ?? [];
};

// ─── Collections ──────────────────────────────────────────────────────────────

export const getCollections = async () => {
  const { data } = await apiClient.get('/collections');
  return data?.content ?? data ?? [];
};

export const getProductsByCollection = async (handle, size = 20, marketCode) => {
  const params = { size };
  if (marketCode) params.marketCode = marketCode;
  const { data } = await apiClient.get(`/collections/${handle}/products`, { params });
  return data?.content ?? data ?? [];
};

// ─── Brands ───────────────────────────────────────────────────────────────────

export const getBrands = async () => {
  const { data } = await apiClient.get('/brands');
  const list = data?.content ?? data ?? [];
  // the API sends { name, slug, productCount } — give each brand a stable id for React lists
  return Array.isArray(list) ? list.map((b) => ({ ...b, id: b.id ?? b.slug ?? b.name })) : [];
};
